import React from "react";
import { Card, StatusPill } from "../ui-bj/Primitives";
import { num, str, fmtDate, arr } from "../../lib/airtableHelpers";
import { relabel } from "../../lib/displayNames";

export const ClientTable = ({ clients, activeId, onRowClick, wide }) => (
  <Card className={`${wide ? "" : "xl:col-span-2"} overflow-x-auto`}>
    <table className="w-full min-w-[900px]">
      <thead>
        <tr className="text-left">
          {["Client ID","Full Name","Package","Active Services","Status","Payment","Joined","Days","Next Appt","Consultant"].map((h) => (
            <th key={h} className="bj-table-header py-2 pr-3 whitespace-nowrap">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {clients.length === 0 && (
          <tr><td colSpan={10} className="py-10 text-center text-[#5E4D40] text-sm">No clients match the filters.</td></tr>
        )}
        {clients.map((c) => {
          const f = c.fields || {};
          const days = num(f["Days as Client"]);
          return (
            <tr
              key={c.id}
              data-testid={`client-row-${c.id}`}
              onClick={() => onRowClick(c.id)}
              className={`bj-table-row cursor-pointer ${activeId === c.id ? "is-active" : ""}`}
            >
              <td className="py-3 pr-3 text-[#6E5022] text-sm bj-tnum">{str(f["Client ID"])}</td>
              <td className="py-3 pr-3 text-[#2A1C15] text-sm">{str(f["Full Name"])}</td>
              <td className="py-3 pr-3 text-sm">{f["Service Package"] ? <StatusPill status={f["Service Package"]} /> : <span className="text-[#5E4D40]">—</span>}</td>
              <td className="py-3 pr-3 text-[#5E4D40] text-xs">
                <div className="flex flex-wrap gap-1">
                  {arr(f["Active Services"]).map((s) => (
                    <span key={s} className="px-1.5 py-0.5 border border-[rgba(42,28,21,0.18)] text-[#2A1C15] text-[0.75rem]">{relabel(s)}</span>
                  ))}
                  {arr(f["Active Services"]).length === 0 && <span>—</span>}
                </div>
              </td>
              <td className="py-3 pr-3">{f["Client Status"] ? <StatusPill status={f["Client Status"]} /> : <span className="text-[#5E4D40] text-sm">—</span>}</td>
              <td className="py-3 pr-3">{f["Payment Status"] ? <StatusPill status={f["Payment Status"]} /> : <span className="text-[#5E4D40] text-sm">—</span>}</td>
              <td className="py-3 pr-3 text-[#5E4D40] text-sm bj-tnum">{fmtDate(f["Date Joined"])}</td>
              <td className="py-3 pr-3 text-[#2A1C15] text-sm bj-tnum">{days === null ? "—" : days}</td>
              <td className="py-3 pr-3 text-[#5E4D40] text-sm bj-tnum">{fmtDate(f["Next Appointment"])}</td>
              <td className="py-3 pr-3 text-[#5E4D40] text-sm">{str(f["Consultant Assigned"])}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </Card>
);
